import { useEffect, useRef } from "react";
import axios from "axios";
import { API, LOGO_URL } from "../lib/api";

export const AuthCallback = () => {
  const processed = useRef(false);

  useEffect(() => {
    if (processed.current) return;
    processed.current = true;

    const sid = new URLSearchParams(window.location.hash.slice(1)).get("session_id");
    (async () => {
      try {
        await axios.post(`${API}/auth/session`, {}, {
          headers: { "X-Session-ID": sid },
          withCredentials: true,
        });
      } catch {
        /* ignore — will land unauthenticated */
      }
      const back = sessionStorage.getItem("lbs_return") || "/";
      sessionStorage.removeItem("lbs_return");
      window.location.replace(back);
    })();
  }, []);

  return (
    <div className="min-h-screen flex flex-col items-center justify-center bg-white">
      <img src={LOGO_URL} alt="LaunchBS" className="h-16 w-16 object-contain animate-float" />
      <p className="mt-4 text-sm text-[#687280]">Signing you in…</p>
    </div>
  );
};
